import {Box} from "@mui/material";
import {SurveyTheme} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";
import {useTranslation} from "react-i18next";
import SurveyRunnerFrame from "../runner/SurveyRunnerFrame";
import SurveyRunnerThemeProvider from "../runner/SurveyRunnerThemeProvider";
import {SurveyProgress} from "../shared/surveyPages.util";

interface Props {
    theme?: SurveyTheme
    language?: string
    progress?: SurveyProgress
    reserveProgressSpace?: boolean
    showLogo?: boolean
    footer?: React.ReactNode
    children: React.ReactNode
}

function PublicSurveyFrame({
    theme,
    language,
    progress,
    reserveProgressSpace,
    showLogo,
    footer,
    children,
}: Props) {
    const {t} = useTranslation(undefined, {lng: language});

    return (
        <SurveyRunnerThemeProvider theme={theme}>
            <Box sx={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                <SurveyRunnerFrame
                    theme={theme}
                    progress={progress}
                    language={language}
                    reserveProgressSpace={reserveProgressSpace}
                    progressLabel={t('Survey progress')}
                    showLogo={showLogo}
                    footer={footer}
                >
                    {children}
                </SurveyRunnerFrame>
            </Box>
        </SurveyRunnerThemeProvider>
    );
}

export default PublicSurveyFrame;
